import React from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useMutation } from 'react-fetching-library';
import { useSelector } from 'react-redux';
import { Box, Stack, Typography, TextField, Button, Modal, Card, CardContent, CardHeader, Checkbox, Alert, LinearProgress, Divider, IconButton } from '@mui/material';
import toast from 'react-hot-toast';
import { sendNotificationAction } from '../../../../services/request';

import CloseIcon from '@mui/icons-material/Close';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

const validationSchema = Yup.object({
  email_message: Yup.boolean(),
  sms_message: Yup.boolean(),
  message: Yup.string().required('To pole nie może być puste'),
  subject: Yup.string().when('email_message', {
    is: true,
    then: Yup.string().required('To pole nie może być puste')
  })
});

export default function SendMessageModal({ order, open, handleClose }) {
  const { module } = useSelector(state => state.app);
  const { mutate, error, loading, reset } = useMutation(sendNotificationAction);

  const handleCloseModal = () => {
    reset();
    handleClose();
    formik.resetForm();
  };

  const handleSubmit = async values => {
    const { error: mutateError } = await mutate(values);
    if (!mutateError) {
      handleCloseModal();
      toast.success('Wiadomość została wysłana');
      // formik.resetForm();
    }
  };

  const formik = useFormik({
    initialValues: {
      email_message: false,
      sms_message: false,
      sms_message_any_number: false,
      message: '',
      subject: ''
    },
    validationSchema,
    validateOnChange: false,
    onSubmit: values => {
      values.order_id = order.id;
      handleSubmit(values);
    }
  });

  return (
    <>
      <Modal
        open={open}
        onClose={handleCloseModal}
      >
        <Card sx={{ ...style, width: '35vw' }}>
          <CardHeader
            title={`Zamówienie ${order.identifier}`}
            sx={{ textAlign: 'center' }}
            action={
              <IconButton color="primary" onClick={handleCloseModal}>
                <CloseIcon />
              </IconButton>
            }
          />
          <CardContent>
            <Stack direction="row" justifyContent="left" spacing={4}>
              {module !== 'zielone_szkoly'
                ? <>
                  <Typography variant="body2">opiekun: <span style={{ fontWeight: 'bold' }}>{order.guardian_name}</span></Typography>
                  <Typography variant="body2">uczestnik: <span style={{ fontWeight: 'bold' }}>{order.participant_name}</span></Typography>
                </>
                : <Typography variant="body2">Osoba reprezentująca szkołę: <span style={{ fontWeight: 'bold' }}>{`${order.office_representative_name} `} {order.office_representative_surname}</span></Typography> }

              <Typography variant="body2">status: <span style={{ fontWeight: 'bold', color: order.state_color }}>{order.state_name}</span></Typography>
            </Stack>
            <Box height={10}/>
            <Divider />
            <Box height={10}/>
            <Stack direction="row" justifyContent="left" spacing={4}>
              <Typography variant="body2">e-mail: <span style={{ fontWeight: 'bold' }}>
                {module !== 'zielone_szkoly' ? order.guardian_correspondence_email : order.office_representative_correspondence_email}</span>
              </Typography>
              <Typography variant="body2">numer telefonu: <span style={{ fontWeight: 'bold' }}>
                {module !== 'zielone_szkoly' ? order.guardian_phone : order.office_representative_phone}</span>
              </Typography>
            </Stack>
            <Box height={10}/>
            <Divider />
            <Box height={10}/>
            <form onSubmit={formik.handleSubmit} style={{ display: 'flex', flexDirection: 'column' }}>
              <Stack direction="row" alignItems="center" justifyContent="left" spacing={4}>
                <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
                  <Checkbox id="email_message" name="email_message" checked={formik.values.email_message} onChange={formik.handleChange} />
                  <Typography variant="subtitle2">Wiadomość E-mail</Typography>
                </Stack>
                <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
                  <Checkbox id="sms_message" name="sms_message" checked={formik.values.sms_message} onChange={formik.handleChange} />
                  <Typography variant="subtitle2">Wiadomość SMS</Typography>
                </Stack>
              </Stack>
              {formik.values.email_message
                ? <>
                  <Box height={20}/>
                  <TextField
                    id="subject"
                    name="subject"
                    label="Temat"
                    value={formik.values.subject}
                    onChange={formik.handleChange}
                    error={formik.errors.subject && formik.touched.subject}
                    helperText={formik.errors.subject}
                  />
                </>
                : null}
              <Box height={20}/>
              <TextField
                id="message"
                name="message"
                multiline
                rows={8}
                label="Treść wiadomości"
                value={formik.values.message}
                onChange={formik.handleChange}
                error={formik.errors.message && formik.touched.message}
                helperText={formik.errors.message}
                disabled={!formik.values.email_message && !formik.values.sms_message}
              />
              { error
                ? <>
                  <Box height={40}/>
                  <Alert variant="outlined" severity="error">Nie udało się wysłać wiadomości</Alert>
                </>
                : null}
              <Box height={40}/>
              { loading
                ? <>
                  <LinearProgress color="success" />
                </>
                : !order.manual_notifications
                  ? <Alert variant="outlined" severity="warning">Powiadomienia ręczne dla tego zamówienia są wyłączone</Alert>
                  : <Button disabled={!formik.values.email_message && !formik.values.sms_message} type="submit" variant="contained">
                  Wyślij wiadomość
                  </Button>}
            </form>
          </CardContent>
        </Card>
      </Modal>
    </>
  );
}

